import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'

interface RemoveMobileDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => Promise<void>
}

export function RemoveMobileDialog({
  open,
  onOpenChange,
  onConfirm
}: RemoveMobileDialogProps) {
  const { t } = useTranslation('conversations')
  const [isRemoving, setIsRemoving] = useState(false)

  const handleConfirm = async () => {
    setIsRemoving(true)
    try {
      await onConfirm()
      onOpenChange(false)
    } finally {
      setIsRemoving(false)
    }
  }

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('preview.removeMobile.title')}</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="text-sm text-muted-foreground">
              <p>{t('preview.removeMobile.description')}</p>
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li>{t('preview.removeMobile.item1')}</li>
                <li>{t('preview.removeMobile.item2')}</li>
                <li>{t('preview.removeMobile.item3')}</li>
                <li>{t('preview.removeMobile.item4')}</li>
              </ul>
              <p className="mt-3 font-medium text-amber-600 dark:text-amber-400">
                {t('preview.removeMobile.warning')}
              </p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isRemoving}>
            {t('common:buttons.cancel')}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={handleConfirm}
            disabled={isRemoving}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {isRemoving ? t('preview.removeMobile.removing') : t('preview.removeMobile.confirmButton')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
